var map = {
	"./what-is-sms-service-de.html": 1646,
	"./what-is-sms-service-en.html": 1647,
	"./what-is-sms-service-es.html": 1648,
	"./what-is-sms-service-fr.html": 1649,
	"./what-is-sms-service-ja.html": 1650,
	"./what-is-sms-service-pt.html": 1651,
	"./what-is-sms-service-zh.html": 1652
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1645;


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/sms-services/help/what-is-sms-service ^\.\/what\-is\-sms\-service\-.*\.html$
// module id = 1645
// module chunks = 0